<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white" inline-actions>
        انتقال بین انبارها
        <template v-slot:avatar>
          <q-icon name="shopping_basket"/>
        </template>
        <template v-slot:action>
          <q-btn icon="close" v-close-popup flat round/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section>
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-5">
          <div class="row">
            <div class="col">
              <q-select
                  class="q-mb-xs"
                  v-model="transferObject.fromStore"
                  filled
                  label="انبار مبدا"
                  use-chips
                  :options="storeList"
                  option-label="StorName"
                  option-value="StorID"
              />
              <q-select
                  class="q-mb-lg"
                  v-model="transferObject.toStore"
                  filled
                  label="انبار مقصد"
                  use-chips
                  :options="destinationStoreList"
                  option-label="StorName"
                  option-value="StorID"
              >
                <template v-slot:append>
                  <q-btn icon="shopping_basket" @click.stop v-if="items && items.length>0" color="indigo" round>
                    <q-tooltip>
                      سبد انتقال
                    </q-tooltip>
                    <q-badge floating :label="items.length" rounded color="red" text-color="white"/>
                    <q-popup-proxy v-if="$q.screen.lt.md">
                      <GoodsTransferItems :transfer-object="transferObject" :items="items" @clear-items="clearItems"
                                          @delete-item="deleteItem" :is-done="0"/>
                    </q-popup-proxy>
                  </q-btn>
                </template>
              </q-select>
            </div>
          </div>
          <div class="row" v-if="transferObject.toStore && transferObject.fromStore">
            <div class="col-xs-12">
              <q-card-section class="no-padding">
                <q-banner inline-actions class="bg-indigo text-white">
                  جستجو در محصولات
                </q-banner>
              </q-card-section>
              <q-card-section class="no-padding">
                <ProductInfoSearchPanel :can-select-group="true"/>
              </q-card-section>
              <q-card-section class="no-padding">
                <ProductInfoSearchResult :by-pass-insert-dialog="false"
                                         :is-selection-form="true"
                                         :show-groups="true"
                                         :view-only="false"
                                         @select-goods="goodsAdding"
                                         :store-id="transferObject.fromStore ?transferObject.fromStore.StorID:-1"/>
              </q-card-section>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-7"
             v-if="!$q.screen.lt.md && transferObject.toStore && transferObject.fromStore">
          <GoodsTransferItems :items="items" @clear-items="clearItems" :is-done="0"
                              @delete-item="deleteItem" @add_transfer-request="addTransferRequest"/>
        </div>
      </div>
    </q-card-section>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import ProductInfoSearchPanel from "@/components/productInfo/ProductInfoSearchPanel";
import ProductInfoSearchResult from "@/components/productInfo/ProductInfoSearchResult";
import GoodsTransferItems from "@/components/store/GoodsTransferItems";

export default {
  name: "GoodsTransferAction",
  components: {GoodsTransferItems, ProductInfoSearchResult, ProductInfoSearchPanel},
  data() {
    return {
      items: [],
      storeList: [],
      destinationStoreList: [],
      transferObject: {
        Id: null,
        fromStore: null,
        toStore: null,
        items: [],
        reason: 'انتقال بین انبارها'
      }
    }
  },
  methods: {
    ...mapActions({
      setStoreList: 'Products/getStoreList',
      insertTransferRequest: 'Products/addGoodsTransfer',
    }),
    addTransferRequest(args) {
      this.insertTransferRequest({
        fromStore: this.transferObject.fromStore,
        toStore: this.transferObject.toStore,
        items: args.items,
        Id: args.transferId
      }).then((res) => {
        this.$emit('transfer-request-added', res[0])
      })
    },
    deleteItem(deleteItem) {
      this.items = this.items.filter(item => item.Goods_ID !== deleteItem.Goods_ID)
    },
    clearItems() {
      this.items = []
    },
    goodsAdding(row) {
      let goodsStock = 0
      switch (this.transferObject.fromStore.StorID) {
        case 1:
          goodsStock = row.GStor1;
          break;
        case 2:
          goodsStock = row.GStor2;
          break;
        case 3:
          goodsStock = row.GStor3;
          break;
        case 4:
          goodsStock = row.GStor4;
          break;
        case 5:
          goodsStock = row.GStor5;
          break;
        case 6:
          goodsStock = row.GStor6;
          break;
      }
      if (goodsStock <= 0) {
        this.$q.notify({
          type: 'negative',
          color: 'negative',
          position: 'top',
          message: 'امکان انتقال کالاهایی با موجودی صفر و یا منفی وجود ندارد'
        })
      } else if (row.selectedCount > goodsStock) {
        this.$q.notify({
          type: 'negative',
          color: 'negative',
          position: 'top',
          message: 'مقدار انتقالی بیشتر از موجودی انبار می باشد'
        })
      } else {
        const founded = this.items.filter(item => item.Goods_ID === row.Goods_ID)
        if (founded.length > 0) {
          this.$q.notify({
            type: 'negative',
            color: 'negative',
            position: 'top',
            message: 'محصول تکراری است'
          })
        } else {
          this.items.unshift(row)
        }
      }
    },
    requireRole(val) {
      if (val === null || val === undefined || val === '') {
        return 'انتخاب الزامی است'
      }
    },
  },
  watch: {
    'transferObject.fromStore': function (newValue) {
      if (newValue) {
        this.destinationStoreList = this.storeList.filter(item => item.StorID !== newValue.StorID)
      } else {
        this.destinationStoreList = []
        this.transferObject.toStore = null
      }
    }
  },
  created() {
    this.setStoreList().then((res) => {
      this.storeList = res;
    })
  }
}
</script>

<style scoped>

</style>